var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1241_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.92 0.480003H4.07998C2.36878 0.480003 0.97998 1.8688 0.97998 3.58V23.42C0.97998 25.1312 2.36878 26.52 4.07998 26.52H23.92C25.6312 26.52 27.02 25.1312 27.02 23.42V3.58C27.02 1.8688 25.6312 0.480003 23.92 0.480003ZM9.03998 10.4V22.18H5.31998V10.4H9.03998ZM5.31998 6.9714C5.31998 6.1034 6.06398 5.44 7.17998 5.44C8.29598 5.44 8.99658 6.1034 9.03998 6.9714C9.03998 7.8394 8.34558 8.54 7.17998 8.54C6.06398 8.54 5.31998 7.8394 5.31998 6.9714ZM22.68 22.18H18.96C18.96 22.18 18.96 16.4388 18.96 15.98C18.96 14.74 18.34 13.5 16.79 13.4752H16.7404C15.24 13.4752 14.62 14.7524 14.62 15.98C14.62 16.5442 14.62 22.18 14.62 22.18H10.9V10.4H14.62V11.9872C14.62 11.9872 15.8166 10.4 18.2222 10.4C20.6836 10.4 22.68 12.0926 22.68 15.5212V22.18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1241_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.6c90f8175adf4fb4fad60823de1d2708.svg";
export { ForwardRef as ReactComponent };